import { render, staticRenderFns } from "./BaseModalConfirm.vue?vue&type=template&id=b8ca9ca2&"
import script from "./BaseModalConfirm.vue?vue&type=script&lang=js&"
export * from "./BaseModalConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports